export default __webpack_public_path__ + "static/media/lampada.1c73bb7d.svg";